import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useClientsState } from "atoms/clientsAtom";

import { BaseLayout } from "components/BaseLayout/BaseLayout";
import { ModalHeader } from "components/Modal/AppModal";
import { NamedInput } from "components/NamedInput/NamedInput";
import { NamedCheckbox } from "components/NamedCheckbox/NamedCheckbox";

import { Bonuses, Discounts, Footer /*Marketing*/ } from "./components";
import styles from "./styles.module.scss";

export type ClientGroupForm = {
  name: string;
  clientgroupid: string;
  avaliable: boolean;
  startpercent: string;
  discountpercent: string;
  shiftpercent: string;
  endpercent: string;
  shiftpercentsum: string;
  nextdiscountsum: string;
  startbonus: string;
  bonuspercent: string;
  startbonussum: string;
  shiftbonus: string;
  endbonus: string;
  maxbonuspay: string;
  shiftbonussum: string;
  nextbonussum: string;
};

export const ClientGroupInfo = ({ isEdit = false }): JSX.Element => {
  const { clientsState } = useClientsState();
  const { handleSubmit, watch, reset, control } = useForm<ClientGroupForm>({
    defaultValues: {
      name: "",
      clientgroupid: "",
      avaliable: false,
      startpercent: "",
      discountpercent: "",
      shiftpercent: "",
      endpercent: "",
      shiftpercentsum: "",
      nextdiscountsum: "",
      startbonus: "",
      bonuspercent: "",
      startbonussum: "",
      shiftbonus: "",
      endbonus: "",
      maxbonuspay: "",
      shiftbonussum: "",
      nextbonussum: "",
    },
  });

  useEffect(() => {
    if (isEdit && clientsState.activeGroupItem) {
      reset({
        name: clientsState.activeGroupItem?.name,
        clientgroupid: clientsState.activeGroupItem?.clientgroupid,
        avaliable: !!clientsState.activeGroupItem?.avaliable,
        startpercent: clientsState.activeGroupItem?.startpercent,
        discountpercent: clientsState.activeGroupItem?.discountpercent,
        shiftpercent: clientsState.activeGroupItem?.shiftpercent,
        endpercent: clientsState.activeGroupItem?.endpercent,
        shiftpercentsum: clientsState.activeGroupItem?.shiftpercentsum || "",
        nextdiscountsum: clientsState.activeGroupItem?.nextdiscountsum,
        startbonus: clientsState.activeGroupItem?.startbonus,
        bonuspercent: clientsState.activeGroupItem?.bonuspercent || "",
        startbonussum: clientsState.activeGroupItem?.startbonussum,
        shiftbonus: clientsState.activeGroupItem?.shiftbonus,
        endbonus: clientsState.activeGroupItem?.endbonus,
        maxbonuspay: clientsState.activeGroupItem?.maxbonuspay,
        shiftbonussum: clientsState.activeGroupItem?.shiftbonussum,
        nextbonussum: clientsState.activeGroupItem?.nextbonussum,
      });
    }
  }, [isEdit, clientsState]);

  return (
    <BaseLayout
      className={styles.settingsModal}
      header={
        <ModalHeader
          title={
            isEdit
              ? clientsState.activeGroupItem?.name || ""
              : watch("name") || "Новая группа"
          }
        />
      }
      footer={
        <Footer
          isEdit={isEdit}
          handleSubmit={handleSubmit}
          canBeSaved={Boolean(watch("name"))}
        />
      }
    >
      <div className="flex gap-16 pt-7">
        <Controller
          name="name"
          control={control}
          render={({ field }) => (
            <NamedInput
              {...field}
              label="Название"
              className={styles.name_input}
            />
          )}
        />
        {isEdit && (
          <Controller
            name="clientgroupid"
            control={control}
            render={({ field }) => (
              <NamedInput
                {...field}
                label="Код"
                className={styles.code_input}
                disabled
              />
            )}
          />
        )}
        <Controller
          name="avaliable"
          control={control}
          render={({ field }) => (
            <NamedCheckbox
              {...field}
              name="Активна"
              checked={field.value}
              onChange={() => {
                field.onChange(!field.value);
              }}
            />
          )}
        />
      </div>
      <div className="mt-5">
        <Discounts control={control} />
      </div>
      <div className="mt-5">
        <Bonuses control={control} />
      </div>
      {/* <div className="mt-5"><Marketing /></div> */}
    </BaseLayout>
  );
};
